import { ReactComponent as User } from "../../assets/user.svg";
import { ReactComponent as Package } from "../../assets/package.svg";
import { ReactComponent as Heart } from "../../../../assets/Vector.svg";
import "./index.scss";
import classNames from "classnames";
import GlobalState, { changeMenuState } from "../../stores/GlobalState";
import { observer } from "mobx-react";
import { runInAction } from "mobx";
import Hearts from "../common/Hearts";
import ContentState from "../../stores/ContentState";
import { useLocation } from "react-router";
import { useEffect, useState } from "react";
import { AccountModel } from "../../stores/UserModel";
const Navigation = observer(() => {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      setVisible(true);
    }, 300);
  }, []);

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        const items = document.querySelectorAll(".navigation__item");

        items.forEach((i) => {
          const href = i.getAttribute("href")?.trim();
          if (href && window.location.href.includes(href)) {
            i.classList.add("active");
          }
        });
      }, 100);
    }
  }, [visible]);

  useEffect(() => {
    if (GlobalState.isMenuOpen) {
      document.querySelector(".hamburger")?.classList.add("active");
    } else document.querySelector(".hamburger")?.classList.remove("active");
  }, [GlobalState.isMenuOpen]);

  return (
    <>
      <nav className={classNames("navigation")}>
        <div className="navigation__list">
          {ContentState.menu?.list?.map((l, id) => {
            let newLink = l.link;
            if (!l.link.includes("https://")) {
              if (
                document.referrer.includes("novaposhtaglobal") &&
                !document.referrer.includes("personal")
              ) {
                newLink = "https://novaposhtaglobal.ua" + l.link;
              }
              if (document.referrer.includes("nova.global")) {
                const basicUrl = GlobalState.currentLocale.lang.includes("En")
                  ? "en-ua/"
                  : GlobalState.currentLocale.lang.includes("ру")
                  ? "ru-ua/"
                  : "ua-ua/";
                newLink = `https://nova.global/${basicUrl}${newLink
                  .replaceAll("en/", "")
                  .replaceAll("ru/", "")
                  .replaceAll("/", "")}`;
              }
            }
            return (
              <a
                href={l.link.includes("http") ? l.link : newLink}
                className={classNames(
                  "navigation__item",
                  l.link.includes("track") && "track"
                )}
                target={l.link.includes("http") ? "__blank" : ""}
                key={id}
                onClick={() => {
                  runInAction(() => {
                    GlobalState.isMenuOpen = false;
                    GlobalState.isLocaleOpen = false;
                  });
                }}
              >
                <span> {l.title}</span>
                {l.link.includes("track") && <Hearts />}
              </a>
            );
          })}
        </div>
        <div className="navigation__func">
          <div
            className={classNames(
              "navigation__func-item package",
              pathname.includes("/track") && "active"
            )}
            onClick={() => {
              let newLink = ContentState.menu!.track;
              if (
                document.referrer.includes("novaposhtaglobal") &&
                !document.referrer.includes("personal")
              ) {
                newLink =
                  "https://novaposhtaglobal.ua" + ContentState.menu!.track;
              }
              if (document.referrer.includes("nova.global")) {
                const basicUrl = GlobalState.currentLocale.lang.includes("En")
                  ? "en-ua/"
                  : GlobalState.currentLocale.lang.includes("ру")
                  ? "ru-ua/"
                  : "ua-ua/";
                newLink = `https://nova.global/${basicUrl}${newLink
                  .replaceAll("en/", "")
                  .replaceAll("ru/", "")
                  .replaceAll("/", "")}`;
              }

              window.location.href = newLink;
            }}
          >
            <Package />
          </div>
          <div
            className={classNames(
              "navigation__func-item user",
              (pathname.includes("/account") ||
                pathname.includes("/login") ||
                pathname.includes("/reg")) &&
                "active"
            )}
            onClick={() => {
              let lang = GlobalState.currentLocale.lang.includes("En")
                ? "/en"
                : GlobalState.currentLocale.lang.includes("ру")
                ? "/ru"
                : "";

              window.location.href = AccountModel.email
                ? `${lang}/account/`
                : `${lang}/login/`;
            }}
          >
            <User />
          </div>

          <div
            className={classNames("navigation__func-item hamburger")}
            onClick={changeMenuState}
          >
            <div className="hamburger__dash"></div>
            <div className="hamburger__dash"></div>
          </div>
        </div>
      </nav>
    </>
  );
});

export default Navigation;
